<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-tickets" size="small" type="text"
                           @click.stop="handleCamerataUser(scope.row)">会员管理({{ scope.row.camerata_user_1_count }})
                </el-button>
                <el-button icon="el-icon-tickets" size="small" type="text"
                           @click.stop="handleCamerataUserExamine(scope.row)">入会审核({{ scope.row.camerata_user_0_count }})
                </el-button>
                <!--<el-button icon="el-icon-tickets" size="small" type="text"-->
                           <!--@click.stop="handleCamerataUserOutExamine(scope.row)">退会审核({{ scope.row.camerata_user_2_count }})-->
                <!--</el-button>-->
                <el-button icon="el-icon-tickets" size="small" type="text"
                           @click.stop="handleCamerataActivity(scope.row)">活动管理({{ scope.row.camerata_activity_count }})
                </el-button>
            </template>
        </avue-crud>

        <el-dialog title="会员管理" :visible.sync="dialogCamerataUserVisible" width="80%" center>
            <CamerataUser v-if="dialogCamerataUserVisible" :defaultParams="{camerataId : this.camerataId, status : 1 }"></CamerataUser>
        </el-dialog>
        <el-dialog title="入会审核" :visible.sync="dialogCamerataUserExamineVisible" width="80%" center>
            <CamerataUserExamine v-if="dialogCamerataUserExamineVisible" :defaultParams="{camerataId : this.camerataId, status : 0 }"></CamerataUserExamine>
        </el-dialog>
        <el-dialog title="退会审核" :visible.sync="dialogCamerataUserOutExamineVisible" width="80%" center>
            <CamerataUserOutExamine v-if="dialogCamerataUserOutExamineVisible" :defaultParams="{camerataId : this.camerataId, status : 2 }"></CamerataUserOutExamine>
        </el-dialog>
        <el-dialog title="活动管理" :visible.sync="dialogCamerataActivityVisible" width="80%" center>
            <CamerataActivity :defaultParams="{camerataId : this.camerataId }"></CamerataActivity>
        </el-dialog>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  import CamerataUser from './CamerataUser'
  import CamerataUserExamine from './CamerataUserExamine'
  import CamerataActivity from './CamerataActivity'
  import CamerataUserOutExamine from './CamerataUserOutExamine'

  export default {
    mixins: [curd],
    components: {CamerataUser, CamerataActivity, CamerataUserExamine, CamerataUserOutExamine},
    data() {
      return {
        dialogCamerataUserVisible: false,
        dialogCamerataUserExamineVisible: false,
        dialogCamerataActivityVisible: false,
        dialogCamerataUserOutExamineVisible: false,
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增同好会', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '会名',
              overHidden: true,
              prop: 'title',
              span: 24,
              align: 'left',
              rules: [{
                type: 'string', required: true, message: '会名不能为空', trigger: 'blur'
              }]
            },
            {
              label: '背景图',
              prop: 'coverpath',
              rules: [{
                required: true, message: '背景图不能为空', trigger: 'blur'
              }],
              type: 'upload',
              listType: 'picture-img', // 单图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            },
            {
              label: '介绍图',
              prop: 'filepaths',
              dataType: 'string', // 单图不要此属性
              type: 'upload',
              // listType: 'picture-img', // 单图
              listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              hide: true,
              span: 24
            },
            {
              label: '会长',
              prop: 'president',
              type: 'tree',
              props: {
                label: 'username',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/user',
              span: 24
            },
            {
              label: '管理员',
              prop: 'manage',
              type: 'tree',
              props: {
                label: 'username',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/user',
              span: 24
            },
            {
              label: '总务',
              prop: 'affair',
              type: 'tree',
              props: {
                label: 'username',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/user',
              span: 24
            },
            {
              label: '介绍内容',
              prop: 'content',
              hide: true,
              type: 'textarea',
              span: 24
            },
            {
              label: '排序id',
              prop: 'sort_id',
              hide: true,
              type: 'number',
              value: 100,
              tip: '排序ID越小越靠前',
              span: 24
            }
          ]
        },
        camerataId: null,
      }
    },
    methods: {
      // 同好会会员管理
      handleCamerataUser(row) {
        this.dialogCamerataUserVisible = true;
        this.camerataId = row.id;
      },
      // 同好会入会审核
      handleCamerataUserExamine(row) {
        this.dialogCamerataUserExamineVisible = true;
        this.camerataId = row.id;
      },

      // 同好会退会审核
      handleCamerataUserOutExamine(row) {
        this.dialogCamerataUserOutExamineVisible = true;
        this.camerataId = row.id;
      },

      // 活动管理
      handleCamerataActivity(row) {
        this.dialogCamerataActivityVisible = true;
        this.camerataId = row.id;
      }
    }
  }
</script>
